import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const financialAccountParameter = 'financial-account' as const;

export const FinancialAccountRewardsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "financialAccountRewards" */
      '../../../components/FinancialAccountRewards/FinancialAccountRewards'
    ),
  enabledOverrideFlag: ComponentOverrideFlag.financial_account_rewards,
  htmlAttributes: {
    [financialAccountParameter]: {isInternal: false},
  },
  customHtmlElementMethods: {
    setFinancialAccount: {
      type: 'AttributeSettingMethod',
      attribute: financialAccountParameter,
      isInternal: false,
      description: 'Sets the financial account id to display rewards for.',
    },
  },
  releaseState: 'preview',
  sentryTeam: 'fa_cash_rewards',
  teamOwner: 'spear',
  description: 'Displays cash reward earnings for a given financial account.',
  friendlyName: 'Financial account rewards',
  enableV2APIToken: true,
};
